import { createAction } from 'redux-actions';

export const GetListEventOfViewerRequested = createAction('GET_LIST_EVENT_OF_VIEWER_REQUESTED');
export const GetListEventOfViewerRequestedReceived = createAction('GET_LIST_EVENT_OF_VIEWER_REQUESTED_RECEIVED');
export const GetListEventOfViewerRequestedReceivedFailure = createAction('GET_LIST_EVENT_OF_VIEWER_REQUESTED_RECEIVED_FAILURE');
export const ClearListEventOfViewer = createAction('CLEAR_LIST_EVENT_OF_VIEWER');

export const UpdateStatusViewerRequested = createAction('UPDATE_STATUS_VIEWER_REQUESTED');
export const UpdateStatusViewerRequestedReceived = createAction('UPDATE_STATUS_VIEWER_REQUESTED_RECEIVED');
export const UpdateStatusViewerRequestedReceivedFailure = createAction('UPDATE_STATUS_VIEWER_REQUESTED_RECEIVED_FAILURE');

export const GetCsvViewerRequested = createAction('GET_CSV_VIEWER_REQUESTED');
export const GetCsvViewerRequestedReceived = createAction('GET_CSV_VIEWER_REQUESTED_RECEIVED');
export const GetCsvViewerReceiveFailure = createAction('GET_CSV_VIEWER_REQUESTED_RECEIVE_FAILURE');
export const GetCsvViewerClear = createAction('GET_CSV_VIEWER_CLEAR');
